(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3120],{

/***/ 10:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/story/alesdanz",
      function () {
        return __webpack_require__(9362);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8014);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(177);
/*@jsxRuntime automatic @jsxImportSource react*/ 


var MDXLayout = _comps_index__WEBPACK_IMPORTED_MODULE_1__/* .SuccessLayout */ .qJ;
function _createMdxContent(props) {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_index__WEBPACK_IMPORTED_MODULE_1__/* .Meta */ .h_, {
                title: "Creator success story - @alesdanz",
                description: "Learn from inspiring success stories of Zoomerang creators on creating and selling video templates on Template Marketplace. See how video creators achieved real results with monetization.",
                tags: "#successfulstory, #videocreator, #videotemplate",
                cover: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_2__/* .assetUrl */ .p)("/covers/success-story.jpg")
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_index__WEBPACK_IMPORTED_MODULE_1__/* .SuccessCover */ .JD, {
                username: "alesdanz",
                nickname: "Alesdanz",
                short: "Alesdanz",
                source: "alesdanz",
                title: "Ready to turn your created content into a reliable source of income while having fun?",
                paragraphs: [
                    "I always had a passion for video making, but I never thought that filming and editing videos on my phone could turn into a career. Starting with no experience, I found success on the short-form video platforms by creating catchy and engaging content.",
                    "It's been a wild ride, but my passion for video making and dedication to creating content that resonates with people has been the key to my success. I can't wait to see where this journey takes me next!"
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_index__WEBPACK_IMPORTED_MODULE_1__/* .SuccessRate */ .vA, {
                engagement: "30%",
                followers: "55K",
                revenue: "$2,000+",
                title: "Expanding Reach and Growing Revenue",
                advice: "As a creator, my main goal with Zoomerang is to showcase my short-form content to a wider audience and generate revenue."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_index__WEBPACK_IMPORTED_MODULE_1__/* .SuccessSupport */ .$, {
                engagement: "30%",
                followers: "55K",
                revenue: "$2,000+",
                support: "The Zoomerang team has been a great support for me in the process of creating and monetizing my content. Thanks to their assistance, I have been able to access intuitive tools and features that have allowed me to produce high-quality videos. Additionally, I have received valuable insights on how to expand my audience and generate revenue through my work.",
                success: "Ever since I started using Zoomerang as a content creator, I've seen a notable improvement in my engagement rates across other social media platforms, as well as an increase in followers and earnings. Here are some of my achievements since joining:"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_index__WEBPACK_IMPORTED_MODULE_1__/* .SuccessQuote */ .EW, {
                name: "Alesdanz",
                role: "Template Creator at Zoomerang",
                quote: "I joined Zoomerang to create short and fun videos, and thanks to this application, I have been able to earn a stable income. If you have skills in video editing, I highly recommend that you join the Zoomerang Template Marketplace.",
                source: "alesdanz"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_index__WEBPACK_IMPORTED_MODULE_1__/* .BlogSocials */ .fC, {})
        ]
    });
}
function MDXContent() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, props)
    }));
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (MDXContent);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(10); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);